<template>
	<Modal @close="close()" title="End session">
		<template v-slot:content>
			<div class="content">
				Patient record has been saved. You can continue where you left off later. <br /><br />
				Would you like to close this patient record?
			</div>
		</template>
		<template v-slot:footer>
			<div class="buttons">
				<button @click="close()" class="button-blank-color roundButton">No</button>
				<button @click="endSession" class="button-primary-color roundButton">Yes</button>
			</div>
		</template>
	</Modal>
</template>

<script>
	import Modal from '../Modal';
	import { autorun } from 'mobx';
	import Cookies from 'js-cookie';

	export default {
		name: 'SignOutModal',
		components: { Modal },
		methods: {
			close() {
				this.$state.utils.displayMetadataWaitingPopup = false;
				this.$emit('close');
			},
			async signOut() {
				await new Promise((r) => setTimeout(r, 100));

				localStorage.removeItem('refresh_token');
				localStorage.removeItem('refresh_expiration');
				localStorage.removeItem('storeID');
				Cookies.remove('mobile-app-redirect-data');
				if (this.$router.currentRoute.name !== 'Index') {
					await this.$router.push('index');
				}
				location.reload();
			},
			async endSession() {
				for (let i = 0; i < 600; i++) {
					if (!this.$state._patient.isDirty) {
						close();
						location.replace(this.$state.redirectUri);
						return;
					}

					this.$state.utils.displayMetadataWaitingPopup = true;
					await new Promise((r) => setTimeout(r, 100));
				}

				this.close();

				location.replace(this.$state.redirectUri);
				location.reload();
			}
		}
	};
</script>

<style lang="scss" scoped>
	.content {
		padding: 3.5rem;
		display: flex;
	}

	.buttons {
		display: flex;
		justify-content: space-evenly;
		width: 45vw;

		button {
			font-size: var(--step--1);
			min-width: 150px;
			min-height: 45px;
			width: 12vw;
			height: 2.5vw;
			border-radius: 72px;
		}

		padding-bottom: calc(var(--step-5) / 2);
	}
</style>
